module.exports = __webpack_public_path__ + "img/Ticket _ Claim.73796f6f.svg";